import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import {
  getDateFormatted,
  deleteAuthToken,
  notifyError,
} from "../../utils/helper";
import {
  downloadCompaniesExcelReport,
  downloadExcelReport,
  downloadUsersExcelReport,
} from "../../requests";
import CustomButton from "../UI/CustomButton";
import styles from "../../_css/DataAccessAndReport.module.css";

const ExportHistoryTable = ({ exportHistoryData, isUserView = true }) => {
  const [loading, setLoading] = useState(false);
  const [downloadId, setDownloadId] = useState(null);
  const navigate = useNavigate();

  const handleDownload = async (id, type) => {
    setDownloadId(id);
    setLoading(true);
    try {
      const response = await downloadExcelReport(id);

      const blob = new Blob([response]);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${type}_export.xlsx`;
      a.click();
    } catch (error) {
      if (error.response?.status === 401) {
        deleteAuthToken();
        navigate("/login");
        notifyError("Session expired, please login again.");
      }
      console.error("Error downloading users excel:", error);
    }
    setDownloadId(null);
    setLoading(false);
  };

  return (
    <div className={`${styles.dataAccessCard} ${styles.exportHistoryCard}`}>
      <span className={styles.exportHistoryTitle}>Export History</span>
      <div className={styles.exportHistoryTableWrapper}>
        <table className={styles.exportHistoryTable}>
          <thead className={styles.exportHistoryThead}>
            <tr>
              <th
                className={`${styles.exportHistoryTh} ${styles.exportHistoryThFirst}`}
              >
                Date &amp; Time
              </th>
              <th className={styles.exportHistoryTh}>Exported By</th>
              <th className={styles.exportHistoryTh}>Data Type</th>
              <th className={styles.exportHistoryTh}>Status</th>
              <th className={styles.exportHistoryTh}>File Format</th>
              <th
                className={`${styles.exportHistoryTh} ${styles.exportHistoryThLast}`}
                style={{ width: "210px" }}
              >
                Download Link
              </th>
            </tr>
          </thead>
          <tbody>
            {exportHistoryData.map((row, index) => {
              const isLastRow = index === exportHistoryData.length - 1;
              return (
                <tr key={row.id ?? index} className={styles.exportHistoryRow}>
                  <td
                    className={`${styles.exportHistoryCell} ${styles.exportHistoryCellFirst}`}
                    data-last={isLastRow ? "true" : "false"}
                  >
                    {getDateFormatted(row.created_at)}
                  </td>
                  <td className={styles.exportHistoryCell}>
                    {row.exported_by}
                  </td>
                  <td className={styles.exportHistoryCell}>{row.data_type}</td>
                  <td className={styles.exportHistoryCell}>
                    {_.toString(row.status) === "1"
                      ? "✅ Completed"
                      : "🔄 Pending"}
                  </td>
                  <td className={styles.exportHistoryCell}>
                    {row.file_format}
                  </td>
                  <td
                    className={`${styles.exportHistoryCell} ${styles.exportHistoryCellLast}`}
                  >
                    <CustomButton
                      disabled={_.toString(row.status) !== "1" || loading}
                      onClick={() => handleDownload(row.id, row.type)}
                      text={
                        loading && row.id === downloadId
                          ? "🔄 Downloading..."
                          : "📥 Download"
                      }
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ExportHistoryTable;
